import type { PropsWithChildren, ReactNode } from 'react';
import React from 'react';
import { CustomerModeContext } from '../hooks/use-customer-mode';

type MaskedContentProps = {
    mask?: ReactNode;
} & PropsWithChildren;

export const MaskedContent: React.FC<MaskedContentProps> = ({ children, mask = '*****' }) => {
    const { customerViewToggled } = React.useContext(CustomerModeContext);

    return <>{customerViewToggled ? mask : children}</>;
};
